/**
 * 4.3.7 walkthrough slides.
 *
 * Each slide:
 *   {
 *     image:          public-path string (e.g. '/walkthroughs/4.3.7/foo.png'),
 *     title:          short heading,
 *     body:           one or two sentences describing the change,
 *     minRoleWeight?: integer — only users with role_weight >= this see the slide
 *                     (matches hasMinRole gating; omit for "visible to everyone")
 *     is_cloud_only?: boolean — true hides the slide on 4.0 campuses, for features
 *                     that only exist on the 5.0 cloud architecture. Omitted or
 *                     false means architecture-independent. Evaluated against the
 *                     campus config's `is_cloud` in collectSlides (index.js).
 *   }
 *
 * Drop walkthrough images under public/walkthroughs/{version}/.
 */
export default [
  {
    image: '/walkthroughs/4.3.7/slide1.png',
    title: 'New Easy Add Device Flow',
    body: 'Now when assigning pendants or other devices, new devices can be added and assigned through the same process with a simplified workflow.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false
  },{
    image: '/walkthroughs/4.3.7/slide2.png',
    title: 'New Guided Helper',
    body: 'A guided helper tool has been added for aiding in accomplishing some of the most common tasks.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false
  },{
    image: '/walkthroughs/4.3.7/slide3.png',
    title: 'New way to move residents',
    body: `We added an additional way to move a resident into a new room from the Residents table page by either clicking the 3-dot kebab menu on the residents row and selecting relocate (red arrows), or via the quick move icon next to the residents current assigned location (orange arrows).`,
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false
  },{
    image: '/walkthroughs/4.3.7/slide4.png',
    title: 'New Industry Proven Sounds',
    body: 'We have updated the sounds within our apps to utilize industry proven sounds for emergency alerting. ' +
        'This includes separate sounds for high priority alerts as well as dedicated sounds for specific device types',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: true
  }
];